/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }       from 'react';
import { useField } from 'formik';
import { styles }   from './styles';

type OptionProps = {
  name:  string;
  label: string;
  value: string;
};

export const Option: FC<OptionProps> = ({ label, ...props }) => {
  const [field, meta] = useField({ ...props, type: 'checkbox' });

  return (
    <label css={[styles.option, field.checked && styles.active]}>
      <div css={styles.check}>
        <input type="checkbox" {...field} />
        { field.checked && 
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" css={styles.check}>
            <path fillRule="evenodd" clipRule="evenodd" d="M16.55 6.08 7.99 14.6l-4.73-4.43.69-.73 4.02 3.77 7.87-7.85z" fill="currentColor"></path>
          </svg>
        }
      </div>
      
      <span>{label}</span>
    </label>
  );
};
